import { render, staticRenderFns } from "./myschedule.vue?vue&type=template&id=482b07c3&scoped=true&"
import script from "./myschedule.vue?vue&type=script&lang=js&"
export * from "./myschedule.vue?vue&type=script&lang=js&"
import style0 from "./myschedule.vue?vue&type=style&index=0&id=482b07c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482b07c3",
  null
  
)

export default component.exports